var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFelchaAbajo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9968 13.1717L16.9468 8.22168L18.3608 9.63568L11.9968 15.9997L5.63281 9.63568L7.04681 8.22168L11.9968 13.1717Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFelchaAbajo);
export default __webpack_public_path__ + "static/media/felchaAbajo.5b3eb24bf184c180197b0b4948aec320.svg";
export { ForwardRef as ReactComponent };